import { type ReactNode } from 'react';
import { DocViewWrapper } from './viewUploadedDoc.styled';

interface TagType {
  id?: string;
  variant?: 'default' | 'primary' | 'success' | 'error' | 'info' | 'dark';
  size?: 'sm' | 'md' | 'lg' | 'Custom' | 'fixed-height';
  icon?: string;
  children: ReactNode;
  className?: string;
  handleOnClick?: () => void;
}

const ViewUploadedDoc = ({
  id,
  variant,
  className,
  size,
  icon,
  children,
  handleOnClick,
}: TagType): JSX.Element => {
  return (
    <DocViewWrapper
      id={id}
      variant={variant}
      className={className ?? 'default'}
      size={size ?? 'md'}
      onClick={handleOnClick}>
      {icon != null && <span className='material-symbols-outlined icon-size'>{icon}</span>}
      {children}
    </DocViewWrapper>
  );
};

export default ViewUploadedDoc;
